module.exports = "/assets/data/8d70409145b9717dc8f8612b53560ae2-NR26.data.json";